import { subflowHref } from "./subflow";

export const ENTERPRISE_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "strategy", label: "Strategy" },
  { id: "connectors", label: "Connectors" },
  { id: "modules", label: "Modules" },
];

export const ENTERPRISE_DRILLS = ENTERPRISE_FLOWS.filter(({ id }) => id !== "overview");

export const ENTERPRISE_FOCUS = {
  overview: {
    title: "Enterprise fit at a glance",
    detail: "Intelligence above the toolchain — not execution inside it.",
  },
  strategy: {
    title: "Technology strategy & guardrails",
    detail: "Replatform vs Refactor against tenant principles. Advisory only.",
  },
  connectors: {
    title: "Enterprise connectors",
    detail: "Authoritative facts in · outcome evidence out. Model=None supported.",
  },
  modules: {
    title: "Master BRD destination map",
    detail: "20 modules · Now / Lean / Next overlay. G1–G8 unchanged.",
  },
};

export function enterpriseFocusHref(appId, focus) {
  return subflowHref("/enterprise", appId, focus);
}
